"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.persistQueryParameters = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * This function transforms query parameters value to lowercase. Once the query
 * parameters are obtained it loops through supported query parameter list to
 * get the value of intended query parameter from the  search parameter object
 * and uses the associated handler to store the value to redux store for later
 * use in the application.
 *
 * @param {URLSearchParams} searchParams URLSearchParams native handler
 * @param {supportedQueryParameterList[]} supportedQueryParameterList parameters to read from search params result and dispatcher to store query string value
 * @param {function()} dispatcher redux store dispatch
 */
var persistQueryParameters = exports.persistQueryParameters = function persistQueryParameters(searchParams, supportedQueryParameterList, dispatcher) {
  /**
   * The following function makes the search params case insensitive.
   */
  var transformedQueryParameters = new URLSearchParams(Array.from(searchParams, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return [key.toLowerCase(), value];
  }));
  supportedQueryParameterList.forEach(function (parameter) {
    var parameterValue = transformedQueryParameters.get(parameter.name);
    if (parameterValue) {
      // Run the handler only if it should not be skipped
      if (!parameter.skip) {
        dispatcher(parameter.handler(parameterValue));
      }

      // Dynamically triggers post-handler logic if defined
      if (typeof parameter.postHandler === 'function') {
        parameter.postHandler(dispatcher);
      }
    }
  });
};